import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Stack,
  Link,
  useTheme,
} from '@mui/material';
import CheckCircle from '@mui/icons-material/CheckCircle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

const Check = () => <CheckCircle sx={{ color: '#06bf58', width: 24, height: 24 }} />;
const Cross = () => <HighlightOffIcon sx={{ color: '#fa0303', width: 28, height: 28 }} />;

const SemanticSearchPlatformComparison = () => {
  const theme = useTheme();
  const tableCellStyle = {
    backgroundColor: theme.palette.mode === 'dark' ? '#2c2c2c' : '#f5f5f5',
  };

  return (
    <Stack sx={{ width: '100%' , marginBottom: 8}}>
      <TableContainer component={Paper} sx={{ boxSizing: 'border-box', boxShadow: 0, border: `2px solid ${tableCellStyle.backgroundColor}`, borderRadius: 2, width: '100%' }}>
        <Table
          sx={{
            border: 'none',
            '& td, & th': {
              border: 'none',
            },
            '& .MuiTableCell-root': {
              textAlign: 'center',
            },
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>
                <Link
                  href="https://consensus.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                  underline="none"
                >
                  <Typography fontSize={18} fontWeight="medium">
                    Consensus
                  </Typography>
                </Link>
              </TableCell>
              <TableCell>
                <Link
                  href="https://www.perplexity.ai/"
                  target="_blank"
                  rel="noopener noreferrer"
                  underline="none"
                >
                  <Typography fontSize={18} fontWeight="medium">
                    Perplexity
                  </Typography>
                </Link>
              </TableCell>
              <TableCell>
                <Link
                  href="https://www.semanticscholar.org/"
                  target="_blank"
                  rel="noopener noreferrer"
                  underline="none"
                >
                  <Typography fontSize={18} fontWeight="medium">
                    Semantic Scholar
                  </Typography>
                </Link>
              </TableCell>
              <TableCell
                sx={tableCellStyle}
              >
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <img
                    src="/logo.png"
                    alt="Endoc logo"
                    style={{
                      height: '40px',
                      width: '35px',
                      marginRight: '8px',
                    }}
                  />
                  <Typography fontSize={18} fontWeight="bold">
                    Endoc
                  </Typography>
                </div>
              </TableCell>

            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell>
                <Typography
                  fontSize={20}
                  fontWeight="bold"
                  align="left"
                >
                  See main content of <br />
                  open access papers
                </Typography>
              </TableCell>
              <TableCell >
                <Cross />
              </TableCell>
              <TableCell >
                <Cross />
              </TableCell>
              <TableCell >
                <Check />
              </TableCell>
              <TableCell  sx={tableCellStyle}>
                <Check />
              </TableCell>
            </TableRow>

          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
};

export default SemanticSearchPlatformComparison;
